module.exports = __webpack_public_path__ + "media/images/pic/teachers/marin-iwai-e0b4dd5a7a010ebabbdd3dd70c51c1ce.webp";